import { CouponDto, ExtraCreditsBenefitType } from "../coupon.ts";

type ExtraCreditsBenefit = {
  type: ExtraCreditsBenefitType;
  benefitText: string;
  extraCredits: number;
};

export type CouponBenefit = ExtraCreditsBenefit;

type GetCouponBenefitForPlanTierParams = {
  planType: "SUBSCRIPTION" | "ONE_OFF";
  credits: number;
  coupon: CouponDto | null;
};

export function getCouponBenefitText(
  planType: "SUBSCRIPTION" | "ONE_OFF",
  coupon: CouponDto,
): string | null {
  if (coupon.config.type !== "EXTRA_CREDITS") {
    return null;
  }

  if (!coupon.config.planTypes.includes(planType)) {
    return null;
  }

  if (planType === "SUBSCRIPTION") {
    return `${1 + coupon.config.multiplier}x credits in first month for all subscriptions`;
  } else if (planType === "ONE_OFF") {
    return `${1 + coupon.config.multiplier}x credits for all one-time purchases`;
  }

  return null;
}

export function getCouponBenefitForPlanTier({
  planType,
  credits,
  coupon,
}: GetCouponBenefitForPlanTierParams): CouponBenefit | null {
  if (!coupon) {
    return null;
  }

  if (coupon.config.type !== "EXTRA_CREDITS") {
    return null;
  }

  if (!coupon.config.planTypes.includes(planType)) {
    return null;
  }

  const multiplier = coupon.config.multiplier;
  const extraCredits = credits * multiplier;

  if (planType === "SUBSCRIPTION") {
    return {
      type: coupon.config.type,
      benefitText: `${1 + multiplier}x credits in first month`,
      extraCredits,
    };
  } else if (planType === "ONE_OFF") {
    return {
      type: coupon.config.type,
      benefitText: `+${extraCredits.toLocaleString("en-US")} extra credits`,
      extraCredits,
    };
  }

  return null;
}
